export default __webpack_public_path__ + "static/landingImg-c85e9a12404e1f637eacb8dac9777a70.png";